export default __webpack_public_path__ + "static/media/svn personal web.4d9aa106.png";